import Vue from 'vue';
import { mask } from 'vue-the-mask';

let app = new Vue({
    el: '#app-product',
    directives: {
        mask,
    },
    data() {
        return {
            quantity: 1,
            loadingBtn: false,
        };
    },
    methods: {
        increment() {
            this.quantity++;
        },
        decrement() {
            if (this.quantity > 1) {
                this.quantity--;
            }
        },
        agregarAlCarrito() {
            const gclidPromise = new Promise(resolve => {
                window.gtag('event', 'add_to_cart', {
                    event_category: PRODUCTO.categoria.nombre,
                    event_label: PRODUCTO.nombre,
                    currency: 'USD',
                    items: [PRODUCTO],
                    value: PRODUCTO.precio,
                });

                setTimeout(resolve, 1500);
            });

            window.fbq('track', 'AddToCart', {
                content_ids: PRODUCTO.id,
                content_name: PRODUCTO.nombre,
                content_type: PRODUCTO.categoria.nombre,
                currency: 'USD',
                value: PRODUCTO.precio,
                contents: PRODUCTO
            });

            gclidPromise.then(() => {
                document.getElementById("app-product").submit();
            });

            this.loadingBtn = true;
        },
    }
});
